import {Component, EventEmitter, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './dialog.work-month-approve.component.html'
})
export class DialogWorkMonthApproveComponent {

  @Output() approveWorkMonthRequest = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {
  }

  onApprove() {
    this.approveWorkMonthRequest.emit();
    this.activeModal.close(true);
  }

  onClose() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.work-month-approve.component.ts